/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cases_Settings_Category_Activetogglearia2Inputs */

const en_cases_settings_category_activetogglearia2 = /** @type {(inputs: Cases_Settings_Category_Activetogglearia2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activate or deactivate ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Activate or deactivate {name}" |
*
* @param {Cases_Settings_Category_Activetogglearia2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_activetogglearia2 = /** @type {((inputs: Cases_Settings_Category_Activetogglearia2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Activetogglearia2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_activetogglearia2(inputs)
});
export { cases_settings_category_activetogglearia2 as "cases_settings_category_activeToggleAria" }